module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAARBAMAAADNtor0AAAAAXNSR0IB2cksfwAAADBQTFRFAAAAQK/3Qa77Qq/5Qa/6Qq/6RK/7Qq/6Q6/7Qq/6Qq/7Qq/6Qq/6QK/6Qq/6QK//Z1lfawAAABB0Uk5TACA/gKDAQPCwYH/gjzDQEJjp/E0AAABVSURBVHicY2BgEFICAgYwMDE2NjZNADPNgJgZxCwNhYIGhgAGKAhAZ84SADN3rVq1pvfVqlWrAhiepaWlGYAIiAKDALhatwY4M/kDNsPwMoFWQEADABpbIW/uSiUDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/temp/ico-briefcase.png
// module id = 751
// module chunks = 1